import { CancelRounded } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';

interface ClearAdornmentProps {
  fieldName: string;
  onClear?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

function ClearAdornment(props: ClearAdornmentProps) {
  return (
    <InputAdornment position='end'>
      <IconButton aria-label={`clear ${props.fieldName}`} onClick={props.onClear} edge='end' size='small'>
        <CancelRounded fontSize='small' />
      </IconButton>
    </InputAdornment>
  );
}

export default ClearAdornment;
